import React from 'react';
import { FileAttachment } from '../messages/FileAttachment';
import { cn } from '../../utils';
import type { FileAttachment as FileAttachmentType } from '../../types/chat';
import './FileAttachmentsList.css';

interface FileAttachmentsListProps {
  attachments: FileAttachmentType[];
  onRemoveAttachment?: (attachmentId: string) => void;
  onViewAttachment?: (attachment: FileAttachmentType) => void;
  showRemoveButton?: boolean;
  className?: string;
  compactMode?: boolean;
  reverseOrder?: boolean;
}

export const FileAttachmentsList: React.FC<FileAttachmentsListProps> = ({
  attachments,
  onRemoveAttachment,
  onViewAttachment,
  showRemoveButton = false,
  className = '',
  compactMode: _compactMode = false,
  reverseOrder: _reverseOrder = false,
}) => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className={cn('file-attachments-list', className)}>
      <div className="file-attachments-list__section">
        <div className="file-attachments-list__items file-attachments-list__items--documents">
          {attachments.map((attachment) => (
            <FileAttachment
              key={attachment.id}
              attachment={attachment}
              onRemove={onRemoveAttachment ? (id) => {
                onRemoveAttachment(String(id));
              } : undefined}
              onView={onViewAttachment}
              showRemoveButton={showRemoveButton}
              className="file-attachments-list__item"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FileAttachmentsList;
